module.exports = __webpack_public_path__ + "static/media/conference-catering-2.11885bdd.jpg";